module.exports = __webpack_public_path__ + "img/logo10.8d0a8f0.jpg";